import { render, staticRenderFns } from "./BuyersDealer.vue?vue&type=template&id=24ee10af&scoped=true&"
import script from "./BuyersDealer.vue?vue&type=script&lang=js&"
export * from "./BuyersDealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ee10af",
  null
  
)

export default component.exports